import styled from 'styled-components';

export default styled.div`
  min-height: 2em;
  font-weight: ${p => p.theme.fontWeight.bold};
  font-size: 16px;
`;
